'use client';
import React, { useState } from 'react';
import Pagination from 'rc-pagination';
import { useRouter, usePathname } from 'next/navigation';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';

interface IProps {
  page: number;
  total: number;
  path?: string;
}

function PaginationCommon({ page, total, path }: IProps) {
  const router = useRouter();
  const pathName = usePathname();
  return (
    <div className="flex justify-center mt-6 max-md:mt-3">
      <Pagination
        pageSize={20}
        total={total}
        current={page}
        align="center"
        showPrevNextJumpers={true}
        className="flex gap-x-3 "
        prevIcon={() => {
          return (
            <div
              className="text-[#838282] size-8 group flex items-center justify-center rounded-sm cursor-pointer group"
              style={{ backgroundColor: 'rgb(90,90,90)' }}
            >
              <IoIosArrowBack color="#838282" className="group-hover:text-white" />
            </div>
          );
        }}
        nextIcon={() => {
          return (
            <div
              className="text-[#838282] size-8 group flex items-center justify-center rounded-sm cursor-pointer group"
              style={{ backgroundColor: 'rgb(90,90,90)' }}
            >
              <IoIosArrowForward color="#838282" className="group-hover:text-white" />
            </div>
          );
        }}
        onChange={(event) => {
          router.push(`${pathName}?page=${event}`);
        }}
      />
    </div>
  );
}

export default PaginationCommon;
